import { concat, isEmpty, map, reduce } from 'lodash';
import { Injectable } from '@angular/core';

import { lazyInject } from '@app/containers/base/decorators/lazy-inject.decorator';
import { Observable, rx } from '@app/shared/rx';
import { IBaseEntityResponse } from '@app/shared/types/entities/base/base.type';
import { IQohInventoryItemVenue } from '@app/shared/types/entities/transfer/transfer.type';

import { IReplenishPercentMap } from '../replenish.types';
import { isSkipReplenish } from '../replenish.utils';
import { AbstractReplenishDataService } from './abstract-replenish-data.service';
import { ReplenishDataSource } from './replenish-data.enums';
import { QohService } from '../../qoh/qoh.service';

@Injectable()
class ReplenishQohDataService extends AbstractReplenishDataService<
  IQohInventoryItemVenue[]
> {
  public static SOURCE_NAME: string = ReplenishDataSource.Qoh;

  @lazyInject(QohService) public qohService: QohService;

  public fetch(params: {
    percentDesMap: IReplenishPercentMap;
  }): Observable<IQohInventoryItemVenue[]> {
    const needFetchSites = reduce(
      params.percentDesMap,
      (sites, destination) => {
        if (isSkipReplenish(destination) || destination.replenished) {
          return sites;
        }

        const inventoryItemIds = map(
          destination.inventory_items,
          'entity_id' || 'item_entity_id',
        );

        if (isEmpty(inventoryItemIds)) {
          return sites;
        }

        return concat(sites, [
          {
            inventory_item_entity_ids: inventoryItemIds,
            site_id: destination.toSite,
          },
        ]);
      },
      [],
    );

    return this.qohService
      .batchFetchQuantityOnHand(needFetchSites)
      .pipe(
        rx.map(
          (qohResponse: IBaseEntityResponse<IQohInventoryItemVenue>) =>
            qohResponse.items,
        ),
      );
  }
}

export { ReplenishQohDataService };
